import { __assign, __read, __rest } from "tslib";
import React, { useState, useEffect } from 'react';
import { RangeSlider } from '@keen.io/ui-core';
import { useSlider } from '@keen.io/react-hooks';
import { ChoroplethChart, GeoAreaMatchStatus, ResponsiveWrapper, LegendBase, fetchMapTopology, theme as defaultTheme, } from '@keen.io/charts';
import { ChartInteractionLegend, GeoMatchError } from './components';
import ChartWidget from '../chart-widget';
import WidgetHeading from '../widget-heading.component';
import WidgetLoader from '../widget-loader.component';
import { choroplethLegendSettings } from './widget-settings';
import { colors } from '@keen.io/colors';
export var ChoroplethChartWidget = function (_a) {
    var _b = _a.legend, legend = _b === void 0 ? choroplethLegendSettings : _b, _c = _a.theme, theme = _c === void 0 ? defaultTheme : _c, title = _a.title, subtitle = _a.subtitle, card = _a.card, tags = _a.tags, _d = _a.geographicArea, geographicArea = _d === void 0 ? 'world' : _d, colorSteps = _a.colorSteps, props = __rest(_a, ["legend", "theme", "title", "subtitle", "card", "tags", "geographicArea", "colorSteps"]);
    var _e = __read(useState(false), 2), geoMatchError = _e[0], setGeoMatchError = _e[1];
    var _f = __read(useState(null), 2), topology = _f[0], setTopology = _f[1];
    var _g = __read(useState(null), 2), loading = _g[0], setLoading = _g[1];
    var _h = useSlider(props.data, [props.valueKey]), min = _h.min, max = _h.max;
    var minValue = min > 0 && max > 0 ? 0 : min;
    var maxValue = min < 0 && max < 0 ? 0 : max;
    var _j = __read(useState(null), 2), range = _j[0], setRange = _j[1];
    useEffect(function () {
        if (geographicArea) {
            setLoading(true);
            fetchMapTopology(geographicArea).then(function (mapTopology) {
                setTopology(mapTopology);
                setLoading(false);
            });
        }
    }, [geographicArea]);
    return (React.createElement(ChartWidget, { cardSettings: card, legendSettings: {
            position: legend.position,
            alignment: legend.alignment,
            layout: legend.layout,
        }, title: function () { return (React.createElement(WidgetHeading, { title: title, subtitle: subtitle, tags: tags })); }, legend: function () {
            var _a;
            return legend.enabled &&
                !geoMatchError && (React.createElement(LegendBase, __assign({ spacing: "thin", fullDimension: true }, legend),
                React.createElement(RangeSlider, { minimum: minValue, maximum: maxValue, tooltipSettings: {
                        enabled: true,
                        position: 'right',
                        theme: 'light',
                        typography: {
                            fontSize: 11,
                            fontStyle: 'normal',
                            fontWeight: 'normal',
                            fontColor: colors.black['500'],
                        },
                        formatValue: (_a = props === null || props === void 0 ? void 0 : props.tooltipSettings) === null || _a === void 0 ? void 0 : _a.formatValue,
                    }, layout: legend.layout, colors: theme.colors, onChange: function (min, max) { return setRange({ min: min, max: max }); }, colorSteps: colorSteps })));
        }, content: function () {
            if (loading)
                return React.createElement(WidgetLoader, null);
            else if (topology) {
                return (React.createElement(ResponsiveWrapper, null, function (width, height) { return (React.createElement(React.Fragment, null, geoMatchError ? (React.createElement(GeoMatchError, { geographicArea: geographicArea })) : (React.createElement(React.Fragment, null,
                    React.createElement(ChoroplethChart, __assign({ theme: theme, svgDimensions: { width: width, height: height }, topology: topology, colorSteps: colorSteps, valuesRange: range, onUpdateGeoMatchStatus: function (status) {
                            return setGeoMatchError(status === GeoAreaMatchStatus.NOT_MATCHED);
                        } }, props)),
                    React.createElement(ChartInteractionLegend, null))))); }));
            }
        } }));
};
export default ChoroplethChartWidget;
